import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';
import { button, buttonActive, buttonImg, buttonImgActive, icon, iconActive, narrow } from './Testimonial.module.scss';
import { hasStringLongerThan } from 'src/utils/helpers';

function Testimonial({ testimonial: { title, testimonials } }) {
  const [active, setActive] = useState(testimonials[0].id);

  const quotes = testimonials.map((testimonial) => testimonial.quote);
  const hasOnlyShortQuotes = hasStringLongerThan(quotes, 350) === false;

  return (
    <Container fluid className="bg-shapes-clouds-dark-v1 px-0 py-6">
      <Container>
        <Row className="justify-content-center align-items-center">
          <Col xs={12} sm={10}>
            <Row noGutters className={`${narrow} mx-auto`}>
              <Col>
                <h2 className="text-uppercase text-gray-450 font-weight-normal text-size-md letter-spacing-xl my-6 text-center">{title}</h2>
                <div className="bg-gradient-tertiary-alt mb-5 pt-2" />
              </Col>
            </Row>
            <Row className={`${hasOnlyShortQuotes ? narrow : ''} mx-auto flex-nowrap overflow-hidden py-3`}>
              {testimonials.map((testimonial) => (
                <Col xs={{ span: 12, order: testimonial.id === active ? 'first' : null }} key={testimonial.id}>
                  <div className="rfs-size-xl font-weight-bold text-white" dangerouslySetInnerHTML={{ __html: testimonial.quote }} />
                </Col>
              ))}
            </Row>
            <Row className={`${narrow} justify-content-center mx-auto py-5`}>
              {testimonials.map((testimonial) => (
                <Col key={testimonial.id} className="d-flex align-items-center justify-content-center mb-3">
                  <button
                    type="button"
                    className={testimonial.id === active ? iconActive : icon}
                    onClick={() => setActive(testimonial.id)}
                    tabIndex={-1}
                    aria-label="tab"
                  >
                    <span />
                  </button>
                </Col>
              ))}
            </Row>
            <Row className={`${narrow} justify-content-between align-items-center d-lg-none mx-auto mb-6 px-3`}>
              {testimonials.map((testimonial) => (
                <button
                  type="button"
                  key={testimonial.id}
                  className={[testimonial.id === active ? buttonImgActive : buttonImg, 'p-0 shadow'].join(' ')}
                  onClick={() => setActive(testimonial.id)}
                  onFocus={() => setActive(testimonial.id)}
                >
                  <GatsbyImage
                    alt="img"
                    image={testimonial.image?.asset?.gatsbyImageData ?? imgFallback}
                    style={{ width: '55px', height: '55px', overflow: 'hidden', borderRadius: '50%' }}
                    imgStyle={{ borderRadius: '50%', overflow: 'hidden' }}
                  />
                </button>
              ))}
            </Row>
          </Col>
        </Row>
        <Row className="justify-content-center align-items-center d-none d-lg-flex mb-lg-6">
          {testimonials.map((testimonial) => (
            <Col key={testimonial.id} xs={12} lg={4}>
              <button
                type="button"
                onClick={() => setActive(testimonial.id)}
                onFocus={() => setActive(testimonial.id)}
                onMouseOver={() => setActive(testimonial.id)}
                className={[testimonial.id === active ? buttonActive : button, 'd-flex align-items-center px-4 text-left'].join(' ')}
                style={{ minHeight: '150px' }}
                aria-label={`testimonial`}
              >
                <Row className="align-items-center flex-nowrap">
                  <Col xs="auto">
                    <GatsbyImage
                      alt="img"
                      image={testimonial.image?.asset?.gatsbyImageData ?? imgFallback}
                      style={{
                        width: '55px',
                        height: '55px',
                        overflow: 'hidden',
                        borderRadius: '50%',
                        boxShadow: '0 11px 32px -8px #000',
                      }}
                      imgStyle={{ borderRadius: '50%', overflow: 'hidden' }}
                    />
                  </Col>
                  <Col className="pl-3">
                    <Col className="font-weight-bold text-size-sm letter-spacing-2xl mb-1 px-0">{testimonial.name}</Col>
                    <Col className="text-size-xs text-line-height-sm letter-spacing-2xl mb-1 px-0">{testimonial.role}</Col>
                    <Col className="font-weight-bold text-green text-size-xs letter-spacing-2xl px-0">{testimonial.company}</Col>
                  </Col>
                </Row>
              </button>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Testimonial;
